import { useState, useEffect } from 'react';

export interface CookiePreferences {
  necessary: boolean;
  analytics: boolean;
  functional: boolean;
  marketing: boolean;
}

export interface CookieConsent {
  preferences: CookiePreferences;
  timestamp: string;
}

export const useCookies = () => {
  const [cookieConsent, setCookieConsent] = useState<CookieConsent | null>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Cargar preferencias de cookies desde localStorage
    const savedConsent = localStorage.getItem('cookieConsent');
    if (savedConsent) {
      try {
        const parsed = JSON.parse(savedConsent);
        setCookieConsent(parsed);
      } catch (error) {
        console.error('Error parsing cookie consent:', error);
      }
    }
    setIsLoaded(true);
  }, []);

  const saveCookiePreferences = (preferences: CookiePreferences) => {
    const consent: CookieConsent = {
      preferences,
      timestamp: new Date().toISOString(),
    };
    
    localStorage.setItem('cookieConsent', JSON.stringify(consent));
    setCookieConsent(consent);
  };

  const hasConsent = (type: keyof CookiePreferences): boolean => {
    if (!cookieConsent) return false;
    return cookieConsent.preferences[type];
  };

  const clearCookieConsent = () => {
    localStorage.removeItem('cookieConsent');
    setCookieConsent(null);
  };

  const getDefaultPreferences = (): CookiePreferences => ({
    necessary: true,
    analytics: false,
    functional: false,
    marketing: false,
  });

  return {
    cookieConsent,
    isLoaded,
    saveCookiePreferences,
    hasConsent,
    clearCookieConsent,
    getDefaultPreferences,
  };
}; 